<!--
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-09 15:20:26
 * @LastEditTime: 2019-08-15 16:03:54
 * @Version: 1.0
 * @Description: 选择条件查询组件
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->
<template>
  <div class="main">
    <el-form
      ref="form"
      :model="dataModal"
      :label-position="'left'"
      label-width="5rem"
    >
      <el-form-item class="selected-conditions" label="已选">
        <el-tag
          v-for="(val, key) in conditions"
          :key="val"
          class="main-color"
          :disable-transitions="true"
          closable
          @close="conditionsClose(key)"
        >{{ conditions[key] }}</el-tag>
        <div class="clear-conditions" @click="cleanAll">
          <i class="el-icon-delete" />清空已选条件
        </div>
      </el-form-item>
      <template v-for=" (item, index) of config">
        <el-form-item :key="index" :label="item.label" :class="item.class">
          <template v-if="!item.component.slot && item.component.type === 'cascader'">
            <el-cascader
              :ref="item.key"
              v-model="dataModal[item.key]"
              :options="item.component.data()"
              :filterable="true"
              :props="{ expandTrigger: 'hover' ,
                        checkStrictly: true}"
              @expand-change="expandChange"
            />
          </template>
          <template v-if="!item.component.slot && item.component.type === 'checkbox-group'">
            <el-checkbox-group v-model="dataModal[item.key]">
              <el-checkbox-button
                v-for="i of item.component.data()"
                :key="i.key"
                :label="`${i.value}`"
              >{{ i.label }}</el-checkbox-button>
            </el-checkbox-group>
          </template>
          <template v-if="!item.component.slot && item.component.type === 'radio-group'">
            <el-radio-group v-model="dataModal[item.key]">
              <el-radio-button
                v-for="i of item.component.data()"
                :key="i.key"
                :label="i.value"
              >{{ i.label }}</el-radio-button>
            </el-radio-group>
          </template>
          <template v-if="item.component.slot">
            <slot :name="item.component.slot" :data="item" :scope="dataModal" />
          </template>
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>
<script>
import Vue from 'vue'
import mixin from './SelectConditionMixin'
export default {
  name: 'SelectCondition',
  mixins: [mixin],
  props: {
    config: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      conditions: {},
      dataModal: {},
      dataChangeTimer: null
    }
  },
  watch: {

    // 数据改变的时候，刷新展示标签
    dataModal: {
      deep: true,
      immediate: true,
      handler: function(val, oldVal) {
        const changeKeys = []
        // 找出变动值的key
        for (const k in val) {
          // if (val[k] != oldVal[k]) {
          changeKeys.push(k)
          // }
        }
        // 遍历每个变动的key, 刷新器对应的标签
        changeKeys.forEach((key, index) => {

          for (const item of this.config) {
            // 判断展示项的值是否是数组
            if (Object.prototype.toString.call(item.key).indexOf('Array') !== -1 && item.key.length > 0) {
              // 判断这个展示项的值是否包含这个键值
              if (item.key.indexOf(key) !== -1) {
                // 如果有自己的标签生成函数
                if (item.showLabel && typeof item.showLabel === 'function') {
                  const condition = item.showLabel.call(this, item)
                  if (condition) {
                    this.conditions[condition.key] = condition.text
                  } else {
                    delete this.conditions[item.key.toString()]
                  }
                } else {
                  const showVal = [] // 要展示的值
                  let isAble = true // 是否要展示
                  for (const i of item.key) {
                    if (val[i] && val[i].toString() !== '') { // 数据不为空
                      showVal.push(val[i])
                    } else {
                      isAble = false
                      break
                    }
                  }
                  if (!isAble) {
                    if (this.conditions[item.key.toString()]) {
                      delete this.conditions[item.key.toString()]
                    }
                  } else {
                    this.conditions[item.key.toString()] = `${item.label}:${showVal.join('-')}`
                  }
                }
                // this.$emit('refresh', this.dataModal)
                break
              }
            }
            // 判断展示项的值是否是字符串
            if (typeof item.key === 'string') {
              // 判断这个展示项的键值是否等于这个键值
              if (item.key === key) {
                // 如果key的数据不为空
                if (val[key] && val[key].toString() !== '') {
                  // 如果有自己的标签生成函数
                  if (item.showLabel && typeof item.showLabel === 'function') {
                    const condition = item.showLabel.call(this, item)
                    if (condition) {
                      this.conditions[condition.key] = condition.text
                    } else {
                      delete this.conditions[item.key.toString()]
                    } // 如果是级联组件
                  } else if (item.component && item.component.type && item.component.type === 'cascader' && item.component.showPath) {
                    this.getNodes(item.key).then(address => {
                      if (address && address.toString !== '') {
                        Vue.set(this.conditions, item.key, `${item.label}:${address.join(',')}`)
                        // this.conditions[item.key] = `${item.label}:${address.join('-')}`
                      } else {
                        delete this.conditions[item.key]
                      }
                    })
                    // const address = this.getNodes(item.key)
                    // if (address && address.toString !== '') {
                    //   this.conditions[item.key] = `${item.label}:${address.join('-')}`
                    // } else {
                    //   delete this.conditions[item.key]
                    // }
                  } else { // 如果val[key]的值是数组
                    if (Object.prototype.toString.call(val[item.key]).indexOf('Array') !== -1) {
                      this.conditions[item.key] = `${item.label}:${val[item.key].join('-')}`
                    } else {
                      this.conditions[item.key] = `${item.label}:${val[item.key]}`
                    }
                   // console.log("ELSE:"+ this.conditions[item.key])
                  }
                } else { // 数据为空的时候
                  delete this.conditions[item.key]
                }
                // this.$emit('refresh', this.dataModal)
                break
              }
            }
          }
        })
        // 发送最新的数据
        if (this.dataChangeTimer) {
          clearTimeout(this.dataChangeTimer)
        }
        this.dataChangeTimer = setTimeout(() => {
          this.$emit('refresh', JSON.parse(JSON.stringify(this.dataModal)))
        }, 50)
      }
    },

  },
  created: function() {
    this.addProperty(this.config)
  },
  methods: {
    // 为数据模型绑定属性
    addProperty(data) {
      if (
        data &&
        Object.prototype.toString.call(data).indexOf('Array') !== -1 &&
        this.config.length > 0
      ) {
        for (const item of data) {
          if (!item.hasOwnProperty('key')) {
            throw Error(
              ' key  attribute of every item of config object   must is  defined !'
            )
          }
          if (Object.prototype.toString.call(item.key).indexOf('Array') !== -1) {
            for (const k of item.key) {
              if (!this.dataModal.hasOwnProperty(k)) {
                if (item.default) {
                  Vue.set(this.dataModal, k, item['default'])
                } else {
                  Vue.set(this.dataModal, k, '')
                }
              }
            }
          } else {
            if (!this.dataModal.hasOwnProperty(item['key'])) {
              if (item.default) {
                Vue.set(this.dataModal, item['key'], item['default'])
              } else {
                Vue.set(this.dataModal, item['key'], item['default'])
              }
            }
          }
        }
      } else {
        throw Error('config object must be a array!')
      }
    },
    // 获取地址的汉字
    getNodes(key) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (key && this.$refs[key]) {
            if (Object.prototype.toString.call(this.$refs[key]).indexOf('Array') !== -1 && this.$refs[key].length > 0 && this.$refs[key][0].getCheckedNodes) {
              if (Object.prototype.toString.call(this.$refs[key][0].getCheckedNodes()).indexOf('Array') !== -1 && this.$refs[key][0].getCheckedNodes().length > 0) {
                resolve(this.$refs[key][0].getCheckedNodes()[0].pathLabels)
              } else if (Object.prototype.toString.call(this.$refs[key][0].getCheckedNodes()).indexOf('Array') === -1) {
                resolve(this.$refs[key][0].getCheckedNodes().pathLabels)
              }
            } else if (Object.prototype.toString.call(this.$refs[key]).indexOf('Array') === -1 && this.$refs[key].getCheckedNodes) {
              if (Object.prototype.toString.call(this.$refs[key].getCheckedNodes()).indexOf('Array') !== -1 && this.$refs[key].getCheckedNodes().length > 0) {
                resolve(this.$refs[key].getCheckedNodes()[0].pathLabels)
              } else if (Object.prototype.toString.call(this.$refs[key].getCheckedNodes()).indexOf('Array') === -1) {
                resolve(this.$refs[key].getCheckedNodes().pathLabels)
              }
            }
          }
        })
      }, 50)
    },
    // 清空填写的所有值
    cleanAll() {
      this.conditions = {}
      this.cleanModal(this.dataModal)
    },
    // 标签移除事件, 把这个展示标签的相关数据绑定清空并且在标签数据中移除这个属性
    conditionsClose(val) {
      if (val) {
        val.split(',').forEach(k => {
          if (Object.prototype.toString.call(this.dataModal[k]).indexOf('Array') !== -1) {
            this.dataModal[k] = []
          } else {
            this.dataModal[k] = ''
          }
        })
        delete this.conditions[val]
      }
    }
  }
}
</script>
 <style lang="scss" scoped>
.main {
  width: 1200px;
  margin: 0 auto 1rem;
  border: 1px solid rgba(229, 229, 229, 1);
  box-sizing: border-box;

  .el-form-item {
    padding-left: 20px;
    padding-right: 20px;

    .el-tag {
      margin-right: 1rem;
    }
  }

  /deep/.el-form {
    .selected-conditions {
      background-color: #f6f6f6;

      .el-form-item__content {
        display: flex;
        flex-wrap: wrap;

        .el-tag {
          margin-top: auto;
          margin-bottom: auto;
        }
      }

      .clear-conditions {
        cursor: pointer;
        color: #999999;
        align-items: flex-end;
        display: block;
        margin-left: auto;
      }
    }

    .capacity-content {
      .el-form-item__content {
        display: flex;
      }

      .el-input {
        margin-right: 1rem;
        width: 80px;
      }

      .des {
        margin-right: 1rem;
      }

      .el-button-ml {
        background-color: #be2316;
        color: #ffffff;
      }
    }

    /*复选组样式 start*/
    .el-checkbox-button {
      margin-right: 1rem;
    }

    .el-checkbox-button:first-child .el-checkbox-button__inner {
      border-radius: 0 !important;
    }

    .el-checkbox-button:last-child .el-checkbox-button__inner {
      border-radius: 0 !important;
    }

    .el-checkbox-button.is-checked .el-checkbox-button__inner {
      background-color: #be2316;
      border-color: #be2316;
      color: #ffffff;
      box-shadow: -1px 0 0 0 #be2316;
    }

    .el-checkbox-button__inner:hover {
      color: #be2316;
    }

    .el-checkbox-button .el-checkbox-button__inner {
      border: none !important;
    }

    .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner {
      border-left-color: #be2316;
    }

    /*复选组样式 end*/
    /*单选组样式 start*/
    .el-radio-button {
      margin-right: 1rem;
    }

    .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 0 !important;
    }

    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 !important;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background-color: #be2316;
      border-color: #be2316;
      color: #ffffff;
      box-shadow: -1px 0 0 0 #be2316;
    }

    .el-radio-button__inner:hover {
      color: #be2316;
    }

    .el-radio-button .el-radio-button__inner {
      border: none !important;
    }

    .el-radio-button.is-checked:first-child .el-radio-button__inner {
      border-left-color: #be2316;
    }

    /*单选组样式 end*/
    .transport-data {
      display: flex;

      .el-input {
        margin-right: 1rem;
      }

      .des {
        margin-right: 1rem;
      }
    }

    .form-item {
      margin-right: 0;

      .form-item-btn {
        background: #be2316;
        border: none;

        i {
          font-size: 14px;
          padding-right: 10px;
        }
      }
    }
  }
}

/deep/.el-cascader {
  min-width: 476px;
}
/deep/.el-form-item__label{
  &:after{
    content: ' : '
  }
}
</style>
